import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { OxenButton } from 'components';
import TitleImage from '../TitleImage';
import Button from '@mui/material/Button';
import config from '../../config';
import { Menu } from 'react-feather';

function NavButton({ label }: { label: string }) {
  return (
    <OxenButton
      label={label}
      variant='text'
      buttonStyle={{
        justifyContent: 'end',
      }}
    />
  );
}

export default function Nav() {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <div
      style={{
        width: '100dvw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '32px 32px',
      }}
    >
      <TitleImage />
      <Button
        onClick={handleClick}
        style={{
          fontWeight: 'bold',
          color: 'white',
        }}
      >
        <Menu />
      </Button>
      <Grid
        container
        justifyContent='end'
        alignItems='end'
        className='links'
        position='fixed'
        flexDirection='column'
        top='96px'
        right='0'
        width='max-content'
        zIndex={999}
        display={open ? 'flex' : 'none'}
        style={{
          backdropFilter: 'blur(10px)',
        }}
      >
        <NavLink to='/'>
          <NavButton label='Migrate' />
        </NavLink>
        <NavLink to='/tos'>
          <NavButton label='Terms of Service' />
        </NavLink>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://docs.getsession.org/session-token-sesh'
        >
          <NavButton label='About SESH 🔗' />
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={`https://etherscan.io/token/${config.esesh.address}`}
        >
          <NavButton label='SESH Ethereum Contract 🔗' />
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={`https://arbiscan.io/token/${config.asesh.address}`}
        >
          <NavButton label='SESH Arbitrum Contract 🔗' />
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://docs.oxen.io/oxen-docs/downloads#oxen-wallet-downloads'
        >
          <NavButton label='Legacy OXEN Wallet 🔗' />
        </a>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://v2.info.uniswap.org/pair/0xbaeca7c35346a8d31811ef971f38603012a12c1e'
        >
          <NavButton label='SESH Uniswap 🔗' />
        </a>
      </Grid>
    </div>
  );
}
